import { DiscoveryProduct } from '@teko/discovery';
import { ProductCardProps } from '@teko/types/ecommerce';
import { useCallback } from 'react';
import {
  useCartV2,
  useFrame,
  useHelper,
  useRelatedProduct,
  useTenantConfig,
} from '../contexts';
import { useHandlerUnderEighteenYearOld } from './useHandlerUnderEighteenYearOld';

interface UseNewProductCard {
  disableHandlerUnder18?: boolean;
}

export const useNewProductCard = (props: UseNewProductCard = {}) => {
  const {
    isAllowATCFromListing,
    contactLink,
    showNewProductGift,
    epicOmni1821,
  } = useTenantConfig();
  const { productHelper } = useHelper();
  const { frames } = useFrame();
  const cartV2 = useCartV2();
  const { uomCodeToDisplayDecimalQuantity, isDisplayUom } = useTenantConfig();
  const { convertProduct } = useHandlerUnderEighteenYearOld();
  const { disableHandlerUnder18 } = props;
  const relatedProductHook = useRelatedProduct();

  const convertNewProductCard = useCallback(
    (el: DiscoveryProduct) => {
      const product: ProductCardProps = {
        ...productHelper.convertNewProductCard(el, {
          cartV2,
          frames,
          showUom: isDisplayUom,
          contactLink,
          showCtaButton: isAllowATCFromListing,
          showNewProductGift,
          relatedProductHook,
          showCtaButtons: !!epicOmni1821,
          showCtaButtonsRelevantProducts: !!epicOmni1821,
        }),
        precisionToDisplayDecimalQuantity:
          uomCodeToDisplayDecimalQuantity === el.productInfo.uomCode ? 3 : 0,
      };

      if (!disableHandlerUnder18) {
        // Implement under 18 flow, follow ECOM-315 for view detail
        const { imageUrl, addToCart } = convertProduct(product);

        product.imageUrl = imageUrl;

        product.addToCart = addToCart;
      }

      return product;
    },
    [cartV2, frames],
  );

  return { convertNewProductCard };
};
